import { useEffect, useState } from "react";
import WorkshopB2BDataService from "../../services/WorkshopB2B";
import ExpertB2BDataService from "../../services/ExpertB2B";
import { useNavigate } from "react-router-dom";
import { useToast } from "@chakra-ui/react";
// import { MultiSelect } from "react-multi-select-component";
import Select from "react-select";
import { State } from "country-state-city";

export const AddB2BWorkshop = () => {
  const navigate = useNavigate();
  const toast = useToast();
  const token = localStorage.getItem("logged_in_user_token");
  const [workshopDate, setWorkshopDate] = useState("");
  const [workshopStartTime, setWorkshopStartTime] = useState("");
  const [workshopEndTime, setWorkshopEndTime] = useState("");

  const [expertList, setExpertList] = useState<any>([]);
  const [corporateList, setCorporateList] = useState([
    "Periferry",
    "Periferry06",
    "Jellyfish",
    "Bhumi",
    "Credences",
    "Unominda",
    "Manoshala",
  ]);

  const [workshopDetails, setWorkshopDetails] = useState<any>({
    title: "",
    date: "",
    status: "tbc",
    start_time: "",
    end_time: "",
    location: "",
    state: "",
    corporate: "",
    expert: "",
    expert_price: "",
    tds: "",
    payment_after_tds: "",
    payment_status: "",
  });

  const states = State.getStatesOfCountry("IN").map((state) => state.name);
  const stateOptions = ["Online", ...states];

  const formattedTime = (inputTime: string) => {
    const parts = inputTime.split(":");

    if (parts.length === 2) {
      let hour = parseInt(parts[0], 10);
      const minute = parts[1];
      let meridiem = "AM";

      if (hour >= 12) {
        meridiem = "PM";
        if (hour > 12) {
          hour -= 12;
        }
      }

      if (hour === 0) {
        hour = 12;
      }

      const formattedTime = `${hour}:${minute} ${meridiem}`;

      return formattedTime;
    }
    return "";
  };

  const formattedDate = (inputDate: string) => {
    const parts = inputDate.split("-");

    if (parts.length === 3) {
      const formattedDate = `${parts[1]}/${parts[2]}/${parts[0]}`;
      return formattedDate;
    }
    return "";
  };

  const handleWorkshopDateChange = (e: any) => {
    setWorkshopDate(e.target.value);
  };
  const handleWorkshopStartTimeChange = (e: any) => {
    setWorkshopStartTime(e.target.value);
  };
  const handleWorkshopEndTimeChange = (e: any) => {
    setWorkshopEndTime(e.target.value);
  };

  const fetchExperts = async () => {
    try {
      const expertRes = await ExpertB2BDataService.getAllB2BExperts(
        token,
        "",
        "",
        ""
      );
      setExpertList(expertRes.data.data);
    } catch (error: any) {
      if (error.response && error.response.status === 401) {
        toast({
          position: "top",
          title: "Authentication Failed.",
          description: "Your session is expired.",
          status: "error",
          duration: 500,
          isClosable: true,
        });
        setTimeout(() => {
          navigate("/login");
        }, 2000);
      }
      console.log(error);
    }
  };

  const fetchUniqueCorporates = async () => {
    try {
      const corporateRes = await WorkshopB2BDataService.getUniqueCorporates();
      setCorporateList((prevList) => {
        const newItems = corporateRes.data.filter(
          (item: string) => !prevList.includes(item)
        );
        return [...prevList, ...newItems];
      });
    } catch (error: any) {
      console.log(error);
    }
  };

  const options = expertList.map((el: any) => ({
    value: el._id,
    label: el.full_name,
  }));

  const handleExpertDetails = (value: any) => {
    const data = expertList.find((el: any) => el._id === value);
    if (data) {
      setWorkshopDetails({
        ...workshopDetails,
        expert: value,
      });
    }
  };

  const handleSubmit = (event: any) => {
    event.preventDefault();
    const expertPrice = parseInt(workshopDetails.expert_price) || 0;
    const tds = parseInt(workshopDetails.tds) || 0;
    const paymentAfterTds = expertPrice - tds;
    const data = {
      ...workshopDetails,
      date: formattedDate(workshopDate),
      start_time: formattedTime(workshopStartTime),
      end_time: formattedTime(workshopEndTime),
      payment_after_tds: paymentAfterTds,
    };

    WorkshopB2BDataService.addB2BWorkshop(token, data)
      .then((response: any) => {
        navigate(`/workshopsb2b`);
      })
      .catch((e: Error) => {
        console.log(e);
      });
  };
  const handleChange = (e: any) => {
    let value = e.target.value;

    setWorkshopDetails({
      ...workshopDetails,
      [e.target.name]: value,
    });
  };

  useEffect(() => {
    fetchExperts();
    fetchUniqueCorporates();
  }, []);

  return (
    <div className="main-wrapper">
      <div className="page_title py-2">Workshops - B2B Workshop</div>
      <div className="p-5">
        <div className="row m-0 justify-content-center">
          <div className="card p-5 col-lg-10">
            <h4 className="mb-3">Basic Info</h4>
            <form
              className="add_assesment_form"
              onSubmit={(e: any) => handleSubmit(e)}
            >
              <div className="form-row">
                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="workshop_date">
                    Workshop Date
                  </label>
                  <input
                    value={workshopDate}
                    onChange={handleWorkshopDateChange}
                    type="date"
                    className="form-control"
                    id="workshop_date"
                    name="workshop_date"
                  />
                </div>
                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="title">
                    Workshop Title
                  </label>
                  <input
                    value={workshopDetails.title}
                    onChange={(e) => handleChange(e)}
                    type="text"
                    className="form-control"
                    id="title"
                    name="title"
                  />
                </div>
                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="start_time">
                    Workshop Start Time
                  </label>
                  <input
                    value={workshopStartTime}
                    onChange={handleWorkshopStartTimeChange}
                    type="time"
                    className="form-control"
                    id="start_time"
                    name="start_time"
                  />
                </div>
                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="end_time">
                    Workshop End Time
                  </label>
                  <input
                    value={workshopEndTime}
                    onChange={handleWorkshopEndTimeChange}
                    type="time"
                    className="form-control"
                    id="end_time"
                    name="end_time"
                  />
                </div>

                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="status">
                    Status
                  </label>
                  <select
                    onChange={(e) => handleChange(e)}
                    className="form-control"
                    value={workshopDetails.status}
                    id="status"
                    name="status"
                  >
                    <option value="tbc">To Be Confirmed</option>
                    <option value="confirmed">Confirmed</option>
                  </select>
                </div>

                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="corporate">
                    Client
                  </label>
                  <div className="input-group align-items-center">
                    <select
                      name="corporate"
                      onChange={(e) => handleChange(e)}
                      className="form-control"
                      value={workshopDetails.corporate}
                      id="accessCode"
                    >
                      <option value="">Choose Client</option>
                      {corporateList.map((client) => (
                        <option key={client} value={client}>
                          {client}
                        </option>
                      ))}
                      <option value="other">Others</option>
                    </select>
                    {workshopDetails.corporate &&
                      !corporateList.includes(workshopDetails.corporate) && (
                        <input
                          onChange={(e) => handleChange(e)}
                          type="text"
                          className="form-control"
                          id="corporate"
                          name="corporate"
                          value={
                            workshopDetails.corporate === "other"
                              ? ""
                              : workshopDetails.corporate
                          }
                          placeholder="Enter Client Name"
                        />
                      )}
                  </div>
                </div>
                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="expert">
                    Expert*
                  </label>
                  <Select
                    id="expert"
                    name="expert"
                    options={options}
                    required
                    placeholder="Choose Expert"
                    isClearable
                    value={options.find(
                      (option: any) => option.value === workshopDetails.expert
                    )}
                    onChange={(option) =>
                      handleExpertDetails(option ? option.value : null)
                    }
                    classNamePrefix="react-select"
                  />
                </div>

                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="state">
                    State
                  </label>
                  <select
                    id="state"
                    name="state"
                    className="form-control"
                    value={workshopDetails.state}
                    onChange={(e) => {
                      if (e.target.value === "Online") {
                        setWorkshopDetails({
                          ...workshopDetails,
                          state: e.target.value,
                          location: "",
                        });
                      } else {
                        handleChange(e);
                      }
                    }}
                    placeholder="Select State"
                  >
                    <option value="">Select State</option>
                    {stateOptions.map((state) => (
                      <option key={state} value={state}>
                        {state}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="expert_price">
                    Expert Price*
                  </label>
                  <input
                    value={workshopDetails.expert_price}
                    onChange={(e) => handleChange(e)}
                    required
                    type="text"
                    className="form-control"
                    id="expert_price"
                    name="expert_price"
                  />
                </div>

                {workshopDetails.state !== "Online" && (
                  <div className="form-group col-md-6 mb-4">
                    <label className="form-label" htmlFor="location">
                      Location
                    </label>
                    <input
                      value={workshopDetails.location}
                      onChange={(e) => handleChange(e)}
                      type="text"
                      className="form-control"
                      id="location"
                      name="location"
                    />
                  </div>
                )}

                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="tds">
                    TDS
                  </label>
                  <input
                    value={workshopDetails.tds}
                    onChange={(e) => handleChange(e)}
                    type="text"
                    className="form-control"
                    id="tds"
                    name="tds"
                  />
                </div>
                {/* <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="payment_after_tds">
                    Payment after TDS
                  </label>
                  <input
                    value={workshopDetails.payment_after_tds}
                    onChange={(e) => handleChange(e)}
                    type="text"
                    className="form-control"
                    id="payment_after_tds"
                    name="payment_after_tds"
                    readOnly
                  />
                </div> */}
                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="status">
                    Payment status
                  </label>
                  <select
                    onChange={(e) => handleChange(e)}
                    className="form-control"
                    value={workshopDetails.payment_status}
                    id="payment_status"
                    name="payment_status"
                  >
                    <option value="">Select</option>
                    <option value="approved">Approved</option>
                    <option value="hold">Hold</option>
                    <option value="rejected">Rejected</option>
                  </select>
                </div>
              </div>

              <button
                type="submit"
                className="btn action-btn mt-3 px-5 submit-button"
              >
                Submit
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};
